/* RESPONSIBLE TEAM: team-app-security */
import Model, { attr, hasMany, belongsTo } from '@ember-data/model';

export default class ScimGroup extends Model {
  @attr('string') declare name: string;
  @attr('string') declare description: string;
  @attr('string') declare external_id: string;
  @attr('number') declare role_id: number;
  @attr('number') declare priority: number;
  @attr('number') declare member_count: number;
  @attr('date') declare created_at: Date;
  @attr('date') declare updated_at: Date;
  @hasMany('scim-user', { async: false }) declare members: import('./scim-user').default[];
  @belongsTo('role', { async: false }) declare role: import('./role').default;
}
